/*
Fork addition: the most recently placed factory, shared between every
placement path (left-panel drop, recipe-suggestion placement,
point-and-click place, inspector add-to-board) and the click-to-place
menu, which preselects it so Enter re-places it immediately.
*/
import {createSharedComposable} from '@vueuse/core';
import {readonly, ref} from 'vue';

export const useLastPlacedFactory = createSharedComposable(() => {
    const lastPlacedName = ref<string | undefined>();

    function setLastPlaced(name: string | undefined) {
        lastPlacedName.value = name;
    }

    return {
        lastPlacedName: readonly(lastPlacedName),
        setLastPlaced,
    };
});
